<template>
  <div class="editor-container">
    <Toolbar
      class="Toolbar"
      :editor="editorRef"
      :defaultConfig="toolbarConfig"
      mode="default"
    />
    <Editor
      class="Editor"
      v-model="valueHtml"
      :defaultConfig="editorConfig"
      @onCreated="handleCreated"
    />
  </div>
</template>

<script setup>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { computed, onBeforeUnmount, ref, shallowRef } from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import uploadApi from "@/api/upload.js";

onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const props = defineProps({
  readonly: {
    type: Boolean,
    default: false,
  },
  fullScreen: {
    type: Boolean,
    default: true,
  },
  defaultUpload: {
    type: Boolean,
    default: false,
  }
});
const emits = defineEmits(["uploadFile"]);

// 富文本编辑器
const editorRef = shallowRef();
// 内容 HTML
const valueHtml = defineModel();
const toolbarConfig = {
  // toolbarKeys: [
  //   "headerSelect",
  //   "bold",
  //   "italic",
  //   "uploadImage",
  //   // "uploadVideo",
  //   "insertLink",
  //   "bulletedList",
  //   "numberedList",
  // ],
};
// if (props.fullScreen) {
//   toolbarConfig.toolbarKeys.push("fullScreen");
// }
const editorConfig = {
  placeholder: "请输入内容...",
  MENU_CONF: {
    // 配置上传图片
    uploadImage: {
      customUpload: update,
    },
    // 上传视频
    uploadVideo: {
      customUpload: update,
    },
    // 继续其他菜单配置...
  },
};

// 上传图片
async function update(file, insertFn) {
  if(props.defaultUpload){
    const F = new FormData();
    F.append("file", file);
    let res = await uploadApi.UploadFile(F);
    const { fullFileUrl, fileName } = res.data;
    insertFn(fullFileUrl, fileName);
    return;
  }
  emits("uploadFile", file, insertFn);
}

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
  if (props.readonly) {
    editor.disable();
  } else {
    editor.enable();
  }
};

defineExpose({
  editorRef,
});
</script>

<style scoped lang="scss">
.editor-container {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .Toolbar {
    border-bottom: 1px solid #e5e5e5;
    .w-e-bar {
      --w-e-toolbar-bg-color: #f0f0f0;
    }
  }

  .Editor {
    flex: 1;
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
